import React from 'react';
import styled from 'styled-components/macro';
import image from './loading.svg';

const LoadingImage = styled.div`
  display: inline-block;
  background-image: url(${image});
  background-size: ${({ width }) => width} ${({ height }) => height};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin-top: 65px;
`;

const LoadingIndicator = ({ width = '112px', height = '30px' }) => (
  <LoadingImage width={width} height={height} />
);

export default LoadingIndicator;
